import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'documentSeries';

const documentSeriesService = {
  getItems: (data) =>
    request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    }),

  getItem: (id) =>
    request({
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    }),

  getOptions: (docTypeId, selectedSeriesId) =>
    request({
      resource: `${baseURL}/options/${encodeURIComponent(docTypeId)}${
        selectedSeriesId ? `?selectedSeriesId=${encodeURIComponent(selectedSeriesId)}` : ''
      }`,
    }),

  createItem: (data) =>
    request({
      method: Methods.POST,
      resource: baseURL,
      data,
    }),

  updateItem: (data) =>
    request({
      method: Methods.PUT,
      resource: baseURL,
      data,
    }),

  deleteItem: (id) =>
    request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    }),
};

export default documentSeriesService;
